import { NgModule } from '@angular/core';
import { FiLoadingComponent } from './fi-loading.component';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';

@NgModule({
    declarations: [FiLoadingComponent],
    exports: [FiLoadingComponent],
    providers: [LoadingService],
})
export class FiLoadingModule {}
